export const ENCOURAGEMENT_QUOTES: string[] = [
  "We are not predicting the future, we are helping to shape it.",
  "Every expert was once exactly where you are now.",
  "Your potential is not fixed — it grows every time you try.",
  "The best time to start was yesterday. The second best time is now.",
  "Curiosity is the engine of achievement.",
  "Success is the sum of small efforts repeated day in and day out.",
  "You don't have to be great to start, but you have to start to be great.",
  "The future belongs to those who learn more skills and combine them in creative ways.",
  "Education is the passport to the future, for tomorrow belongs to those who prepare for it today.",
  "The only limit to our realisation of tomorrow is our doubts of today.",
  "What you get by achieving your goals is not as important as what you become by achieving them.",
  "Develop a passion for learning. If you do, you will never cease to grow.",
  "The mind is not a vessel to be filled but a fire to be kindled.",
  "You are braver than you believe, stronger than you seem, and smarter than you think.",
  "It always seems impossible until it's done.",
  "In the middle of difficulty lies opportunity.",
  "The secret of getting ahead is getting started.",
  "An investment in knowledge pays the best interest.",
  "The harder you work for something, the greater you'll feel when you achieve it.",
  "Push yourself, because no one else is going to do it for you.",
  "Great things never come from comfort zones.",
  "Work hard in silence; let your success be your noise.",
  "You were not born to fit in — you were born to stand out.",
  "Every day is a chance to be better than yesterday.",
  "The journey of a thousand miles begins with a single step.",
  "Your story is just getting started. Keep turning the pages.",
  "You have everything you need — the question is whether you'll use it.",
  "Don't watch the clock. Do what it does. Keep going.",
  "A winner is just a dreamer who never gave up.",
  "The version of you five years from now is being built today.",
]
